import { STTService, TranscriptionResult } from "../types/stt";

export class ElevenLabsSTTService implements STTService {
  private apiKey: string;

  constructor(apiKey: string) {
    this.apiKey = apiKey;
  }

  get name() {
    return "ElevenLabs Speech-to-Text";
  }

  async transcribe(audioBlob: Blob): Promise<TranscriptionResult> {
    const startTime = performance.now();

    try {
      const formData = new FormData();
      formData.append("file", audioBlob);
      formData.append("model_id", "scribe_v1");
      formData.append("tag_audio_events", "true");
      formData.append("diarize", "true");

      const response = await fetch(
        "https://api.elevenlabs.io/v1/speech-to-text",
        {
          method: "POST",
          headers: {
            "xi-api-key": this.apiKey,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`ElevenLabs API error: ${response.statusText}`);
      }

      const data = await response.json();
      const endTime = performance.now();
      const processingTime = (endTime - startTime) / 1000;

      return {
        model: this.name,
        text: data.text,
        confidence: 1.0, // ElevenLabs doesn't provide confidence scores
        processingTime,
      };
    } catch (error) {
      console.error("ElevenLabs STT error:", error);
      throw error;
    }
  }
}
